import React from "react";
import { Box, Typography, Container, Paper, Button, Stack } from "@mui/material";
import { useNavigate } from "react-router";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import QueryStatsIcon from "@mui/icons-material/QueryStats";

export default function ForecastPage() {
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: "100vh", py: { xs: 4, md: 8 } }}>
      <Container maxWidth="lg">
        <Paper
          elevation={3}
          sx={{
            p: { xs: 4, md: 5 },
            borderRadius: 3,
            textAlign: "left",
          }}
        >
          <Stack direction={{ xs: "column", md: "row" }} spacing={3} alignItems="center" justifyContent="center">
            <AccessTimeIcon sx={{ fontSize: 48, color: "primary.main" }} />
            <Box flex={1}>
              <Typography variant="h4" sx={{ fontWeight: 800, mb: 1 }}>
                Forecast
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Forward-looking analytics and scenario planning are coming soon. We’re building a forecasting workspace so you can value companies dynamically and clearly.
              </Typography>
            </Box>
          </Stack>
        </Paper>

        <Paper
          elevation={3}
          sx={{
            mt: 4,
            p: { xs: 4, md: 5 },
            borderRadius: 3,
            display: "flex",
            alignItems: "center",
            gap: 2.5,
          }}
        >
          <QueryStatsIcon sx={{ fontSize: 36, color: "primary.main" }} />
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 0.5 }}>
              Coming soon
            </Typography>
            <Typography variant="body2" color="text.secondary">
              We’re finalizing the forecasting tools. In the meantime, browse companies in the directory.
            </Typography>            
            <Button variant="contained" onClick={() => navigate("/companies")} sx={{ px: 3, mt: 2 }}>
              Explore companies
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}
